import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent implements OnInit {
//#region properties

  //#region private
  //#endregion

  //#endregion

  //#region setters
  //#endregion

  //#region getters
  public get loaderVisible$(): Observable<boolean> {
    return this.loaderService.loaderVisible$;
  }
  //#endregion

  //#region ctor
  constructor(public loaderService: LoaderService) { }
  //#endregion

  //#region life cycle hooks
  ngOnInit(): void {
  }
  //#endregion

  //#region public action
  public isVisible() {
    let result = this.loaderService.loaderVisible;
    return result;
  }
  //#endregion

}
